/* Import your third-Party plugins here */

import 'js/modernizr.js';
import 'js/jquery.js';
import 'js/perfect-scrollbar.js';
import 'js/l20n.js';

import 'js/vendor/prism/prism.js';
import 'js/vendor/select2/select2.js';
import 'js/vendor/timeline/timeline.js';
import 'js/vendor/ion.rangeSlider/ion.rangeSlider.js';

import 'bower_components/d3/d3.js';
import 'bower_components/c3/c3.js';
import 'bower_components/chart.js/dist/Chart.js';
import 'bower_components/gmaps/gmaps.min.js';
import 'bower_components/raphael/raphael.min.js';
import 'bower_components/morris.js/morris.min.js';
import 'bower_components/leaflet/dist/leaflet.js';
import 'bower_components/moment/min/moment.min.js';
import 'bower_components/dropzone/dist/dropzone.js';
import 'bower_components/seiyria-bootstrap-slider/dist/bootstrap-slider.min.js';
import 'bower_components/jquery-ui/jquery-ui.min.js';
import 'bower_components/vex/js/vex.combined.min.js';
import 'bower_components/codemirror/lib/codemirror.js';
import 'bower_components/trumbowyg/dist/trumbowyg.min.js';
import 'bower_components/switchery/dist/switchery.min.js';
import 'bower_components/filament-tablesaw/dist/tablesaw.js';
import 'bower_components/bootstrap-sass/assets/javascripts/bootstrap/transition.js';
import 'bower_components/bootstrap-sass/assets/javascripts/bootstrap/collapse.js';
import 'bower_components/bootstrap-sass/assets/javascripts/bootstrap/tooltip.js';
import 'bower_components/bootstrap-sass/assets/javascripts/bootstrap/popover.js';
import 'bower_components/messenger/build/js/messenger.min.js';
import 'bower_components/jquery-knob/dist/jquery.knob.min.js';
import 'bower_components/blueimp-gallery/js/blueimp-gallery.js';
import 'bower_components/jquery.steps/build/jquery.steps.min.js';
import 'bower_components/codemirror/mode/javascript/javascript.js';
import 'bower_components/typeahead.js/dist/typeahead.jquery.min.js';
import 'bower_components/jquery-validation/dist/jquery.validate.min.js';
import 'bower_components/kapusta-jquery.sparkline/dist/jquery.sparkline.js';
import 'bower_components/x-editable/dist/bootstrap3-editable/js/bootstrap-editable.js';
import 'bower_components/x-editable/dist/inputs-ext/address/address.js';
import 'bower_components/x-editable/dist/inputs-ext/typeaheadjs/typeaheadjs.js';
import 'bower_components/eonasdan-bootstrap-datetimepicker/src/js/bootstrap-datetimepicker.js';
import 'bower_components/bootstrap-daterangepicker/daterangepicker.js';
import 'bower_components/datatables/media/js/jquery.dataTables.js';
import 'bower_components/bootstrap-treeview/dist/bootstrap-treeview.min.js';
import 'js/vendor/fullcalendar/fullcalendar.js';
import 'js/vendor/datatables/responsive.js';
import 'js/vendor/jcrop/color.js';
import 'js/vendor/jcrop/jcrop.js';

import 'js/rubix.js';



// WEBPACK FOOTER //
// ./src/plugins.js